import React, { Component } from "react";
import FilterSelectAddFilterButton from "./FilterSelectAddFilterButton";
import moment from "moment";
import {
  DayPickerRangeController,
  DayPickerSingleDateController,
} from "react-dates";
import ReactInputMask from "react-input-mask";
import { isPropsForLogicalOperator } from "./LogicalOperatorsOptions";

// format of how date is treated in the FE
export const DATE_FORMAT = "MM/DD/YYYY";
// format of how the date is treated in the BE
export const DATE_QB_FORMAT = "YYYY-MM-DD";

class LogicalOperatorInBetweenDate extends Component {
  constructor(props) {
    super();
    this.state = isPropsForLogicalOperator(props)
      ? props.logicalOperator.value
      : {
          startDate: moment().format(DATE_FORMAT),
          endDate: moment().format(DATE_FORMAT),
          startDateValid: moment(),
          endDateValid: moment(),
          focusedInput: "startDate",
        };

    if (isPropsForLogicalOperator(props)) {
      this.state.startDateValid = moment(this.state.startDateValid);
      this.state.endDateValid = moment(this.state.endDateValid);
    }
  }
  /**
   * Set the value in the current Filter
   */
  onApplyFilter = () => {
    this.props.onApplyFilter && this.props.onApplyFilter(this.state);
  };

  /**
   * Set the selected dates into state which reflects into inputs and DatePicker
   * @param {*} input
   */
  onChangeDate = (input) => {
    this.setState({
      [input.target.id]: input.target.value,
      focusedInput: input.target.id,
    });

    if (this.isDateValid(input.target.value))
      this.setState({
        [input.target.id + "Valid"]: moment(input.target.value, DATE_FORMAT),
      });
  };

  onFocusChange = (focusedInput) =>
    this.setState({ focusedInput: focusedInput || "startDate" });

  /** Check whether a date is valid or not from the input context */
  isDateValid = (date) =>
    date.trim().length === 10 && moment(date, DATE_FORMAT).isValid();

  render() {
    const isStartDateValid = this.isDateValid(this.state.startDate);
    const isEndDateValid = this.isDateValid(this.state.endDate);
    return (
      <>
        <div className="p-2 filter-container">
          <div className="form-row">
            <div className="col">
              <ReactInputMask
                type="text"
                id="startDate"
                value={this.state.startDate}
                className={
                  "form-control form-control-sm " +
                  (!isStartDateValid ? "is-invalid" : "")
                }
                placeholder={
                  this.props.singDatePicker ? "Input date" : "Start date"
                }
                mask="99/99/9999"
                onChange={this.onChangeDate}
                maskChar=""
              />
            </div>
            {!this.props.singDatePicker && (
              <div className="col">
                <ReactInputMask
                  type="text"
                  id="endDate"
                  value={this.state.endDate}
                  className={
                    "form-control form-control-sm " +
                    (!isEndDateValid ? "is-invalid" : "")
                  }
                  placeholder="End date"
                  mask="99/99/9999"
                  onChange={this.onChangeDate}
                  maskChar=""
                />
              </div>
            )}
          </div>
          <div className="form-row">
            <div className="col">
              <div className="input-group mt-1">
                {this.props.singDatePicker ? (
                  <DayPickerSingleDateController
                    noBorder
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel
                    daySize={32}
                    orientation="horizontal"
                    calendarInfoPosition={"after"}
                    onFocusChange={this.onFocusChange}
                    date={this.state.startDateValid}
                    onDateChange={(date) =>
                      this.setState({
                        startDateValid: date,
                        startDate: date
                          ? date.format(DATE_FORMAT)
                          : this.state.startDate,
                      })
                    }
                  />
                ) : (
                  <DayPickerRangeController
                    noBorder
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel
                    daySize={32}
                    orientation="horizontal"
                    calendarInfoPosition={"after"}
                    focusedInput={this.state.focusedInput}
                    onFocusChange={this.onFocusChange}
                    startDate={this.state.startDateValid}
                    endDate={this.state.endDateValid}
                    onDatesChange={({ startDate, endDate }) => {
                      this.setState({
                        startDateValid: startDate,
                        endDateValid: endDate,
                        startDate: startDate
                          ? startDate.format(DATE_FORMAT)
                          : this.state.startDate,
                        endDate: endDate
                          ? endDate.format(DATE_FORMAT)
                          : this.state.endDate,
                      });
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <FilterSelectAddFilterButton
          disabled={
            (this.props.singDatePicker && !isStartDateValid) ||
            !isStartDateValid ||
            !isEndDateValid
          }
          onClick={this.onApplyFilter}
        />
      </>
    );
  }
}

export default LogicalOperatorInBetweenDate;
